import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Inbox, AlertTriangle, Globe, Sparkles } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ total: 0, urgent: 0, nri: 0, new: 0 });
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [s, l] = await Promise.all([api.get("/admin/stats"), api.get("/admin/leads")]);
        setStats(s.data);
        setRecent(l.data.slice(0, 6));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const cards = [
    { k: "Total enquiries", v: stats.total, icon: Inbox },
    { k: "New (unread)", v: stats.new, icon: Sparkles },
    { k: "Urgent", v: stats.urgent, icon: AlertTriangle },
    { k: "NRI", v: stats.nri, icon: Globe },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="kbd">— Overview</div>
      <h1 className="mt-4 font-serif text-5xl tracking-tightest">Practice inbox</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
        {cards.map((c) => (
          <div key={c.k} className="hairline p-6 bg-white/70">
            <div className="flex items-center justify-between">
              <div className="kbd">{c.k}</div>
              <c.icon size={16} className="text-ink-muted"/>
            </div>
            <div className="font-serif text-5xl tracking-tightest mt-4">{loading ? "—" : c.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-12">
        <div className="flex items-center justify-between">
          <h2 className="font-serif text-3xl tracking-tightest">Recent enquiries</h2>
          <Link to="/admin/leads" className="kbd hover:text-ink">View all →</Link>
        </div>
        <div className="mt-6 hairline bg-white/70 divide-y divide-black/10">
          {recent.length === 0 && !loading && <div className="p-6 text-ink-muted">No enquiries yet.</div>}
          {recent.map((l) => (
            <div key={l.id} data-testid={`recent-lead-${l.id}`} className="p-4 md:p-6 grid grid-cols-12 gap-4 items-center">
              <div className="col-span-6 md:col-span-3">
                <div className="text-sm font-medium">{l.name}</div>
                <div className="kbd">{l.email}</div>
              </div>
              <div className="col-span-6 md:col-span-2 kbd">{l.country}</div>
              <div className="col-span-6 md:col-span-2 kbd">{l.source}</div>
              <div className="col-span-6 md:col-span-3 text-sm text-ink-muted truncate">{l.condition || l.message || "—"}</div>
              <div className="col-span-12 md:col-span-2 kbd text-right">{(l.created_at||"").slice(0,10)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
